module.exports = __webpack_public_path__ + "assets/img/14.8e6fb5fd.png";